<template>
    <form style="display: contents" :action="`/review/${currentReview.id}/love`" method="post" @submit.prevent="submit()">
        <button type="submit" :disabled="isProcessing">
            <svg class="heart" :class="{ 'active': lovedByAuthUser }">
                <use xlink:href="#heart"></use>
            </svg>
            <small v-text="currentReview.users_loved.length"></small>
        </button>
    </form>
</template>
<script>
export default {

    props: ['review'],

    data(){
        return {
            currentReview :this.review,
            isProcessing: false,
        }
    },

    methods: {
        submit() {
            this.isProcessing = true
            axios.patch(`/review/${this.currentReview.id}/love`)
                .then(response => {
                    this.currentReview = response.data.review
                    this.isProcessing = false
                })
                .catch(errors => {
                    this.isProcessing = false
                })
        }
    },

    computed: {
        lovedByAuthUser() {
            if (config.user) {
                return !!_.find(this.currentReview.users_loved, user => user.id == config.user.id)
            }
            return false;
        }
    }
}
</script>
